import React from 'react';
import Image from 'next/image';

export const Thumb = ({selected, onClick, imgSrc, img}) => {

  const {src, alt, height, width, formats} = img;
  const {thumbnail} = formats;

  return <div
      className={`embla__slide embla__slide--thumb w-32 h-32 ${
          selected ? 'is-selected' : ''
      }`}
  >
    <button
        onClick={onClick}
        className="embla__slide__inner embla__slide__inner--thumb h-full w-full"
        type="button"
    >
      <Image
          className={'embla__slide__thumbnail z-0'}
          src={thumbnail.url}
          alt={alt}
          layout={'fill'}
          objectFit="cover"
          objectPosition={'center'}
      />
      {/*<img className="embla__slide__thumbnail" src={src} alt={alt}/>*/}
    </button>
  </div>;
};
